<template>
  <div>
    <card>
      <h4 slot="header" class="card-title">User Profile</h4>
      <form v-if="user">
        <div class="row">
          <div class="col-12">
            <img :src="user.photoURL">
          </div>
        </div>
        <div class="row">

          <div class="col-12">
            <base-input v-model="user.email"
                        label="Username"
                        placeholder="Username"
                        readonly
                        type="text">
            </base-input>
          </div>
        </div>

        <div class="row">
          <div class="col-12">
            <base-input v-model="user.displayName" label="Full Name"
                        placeholder="Full Name"
                        readonly
                        type="text">
            </base-input>
          </div>
        </div>

        <div class="clearfix"></div>
      </form>
    </card>
    <p>If needed, please contact <a href="mailto:roy@cytoreason.com">Roy Amram</a> to change your profile details.</p>
  </div>
</template>
<script>
import Card from 'src/components/Cards/Card.vue';
import { firebase } from '../../services/FirebaseService';
import { first } from 'rxjs';

export default {
  components: {
    Card,
  },
  data: () => ({
    user: firebase.auth.currentUser,
  }),
  mounted() {
    firebase.user$.pipe(first()).subscribe(() => this.user = firebase.auth.currentUser);
  },
};

</script>
<style>

</style>
